import { FileModel } from "../../../Shared/dto/create-file-input";

export class CreateDriverInput {
  id?:          string;
  companyId?:   string;
  vehicleId?:   string;
  firstName?:   string;
  middleName?:  string;
  lastName?:    string;
  phoneNumber?: string;
  otherNumber?: string;
  email?:       string;
  address?:     string;
  licenses?:    FileModel[];
  passports?:    FileModel[];
  pictures?:    FileModel[];
}
